const tableCellGroup = {
  Typography: 'Deseja realmente deletar este item?'
};

export default tableCellGroup;
